import Konva from "konva";
import { categories } from "~/constants/categories";
import { hexToRgb, rgbaToHex } from "@/utils/helpers.js";
import { addServerPath } from "@/plugins/add-server-path";
import { STORAGE_BACKGROUND_PATH, STORAGE_IMAGE_PATH, BUILD_GENERAL_STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import cloneDeep from "lodash/cloneDeep"

function waitForNextPaint() {
  return new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(resolve))
  })
}

function waitForImage(image) {
  if (!image || image.complete) return Promise.resolve()

  return new Promise((resolve) => {
    image.addEventListener('load', resolve, { once: true })
    image.addEventListener('error', resolve, { once: true })
  })
}

async function loadExportImages(element) {
  if (!element) return

  const images = Array.from(element.querySelectorAll('img'))
  images.forEach((image) => {
    const dataSrc = image.getAttribute('data-src')
    if (dataSrc && !image.getAttribute('src')) {
      image.setAttribute('src', dataSrc)
    }
  })

  await Promise.all(images.map(waitForImage))
}

async function prepareElementForExport(elementId) {
  if (!process.client || !elementId) return null

  const element = document.getElementById(elementId)
  if (!element) return null

  window.dispatchEvent(new CustomEvent('vistat:prepare-export', {
    detail: {
      elementId,
      element,
    },
  }))

  await waitForNextPaint()
  await loadExportImages(element)
  await waitForNextPaint()
  return element
}

export const state = () => ({
  counter: 0,
})

export const actions = {
  async nuxtServerInit({ dispatch, query, state }) {
    await dispatch('property_templates/getConsts')
    await dispatch('categories/getNavTree')
    await dispatch('objects/getTypesAndTemplatesConsts')
  },
  async nuxtClientInit({ commit, dispatch }, context) {
    await dispatch('property_templates/getConsts')
    await dispatch('categories/getNavTree')
    await dispatch('objects/getTypesAndTemplatesConsts')

    setInterval(() => {
      dispatch('property_templates/refreshConsts')
    }, 300000) // 5min
  },
  async downloadImage(state, url) {
    return this.$axios.$get(`/misc/download_image/?url=${encodeURIComponent(url)}`, {
      responseType: 'blob',
    })
  },
  async uploadFile(state, { file, url, filename }) {
    let blob
    const formData = new FormData();
    let resolvedFilename = filename

    if (typeof File !== 'undefined' && file instanceof File) {
      blob = file
      resolvedFilename = resolvedFilename || file.name
    } else if (file instanceof Blob) {
      blob = file
    } else {
      const base64Response = await fetch(file);
      blob = await base64Response.blob();
    }

    if (resolvedFilename) {
      formData.append('file', blob, resolvedFilename);
      formData.append('filename', resolvedFilename);
    } else {
      formData.append('file', blob);
    }
    formData.append('content_type', blob.type)
    if (url) formData.append('url', url)

    return this.$axios.$post(`${process.env.BASE_URL_V2}/admin/uploader/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  async generalUploadImage(state, params) {
    return this.$axios.$post(`${process.env.BASE_URL_V2}/admin/uploader/store/`, params);
  },
  makeScreenshotOfSectionOld({}, { elementId, fileName = 'скриншот' }) {
    if (process.client) {
      return new Promise((resolve, reject) => {
        import("html2canvas").then(({ default: html2canvas }) => {
          const element = document.getElementById(elementId);

          html2canvas(element, {
            useCORS: true, backgroundColor: '#F9FEFF',
          })
            .then((canvas) => {
              // Создаем новый canvas с отступами
              let padding = 20; // Размер отступа
              let paddedCanvas = document.createElement('canvas');
              paddedCanvas.width = canvas.width + padding * 2;
              paddedCanvas.height = canvas.height + padding * 2;

              let pctx = paddedCanvas.getContext('2d');
              pctx.fillStyle = "white"
              pctx.fillRect(0, 0, paddedCanvas.width, paddedCanvas.height)

              // Рисуем исходный canvas в центре нового
              pctx.drawImage(canvas, padding, padding);

              const link = document.createElement('a');
              link.href = paddedCanvas.toDataURL('image/png');
              link.download = `${fileName}.png`;
              link.click();

              resolve()
            })
            .catch((error) => {
              reject(error)
            })
        });
      })
    }
  }, async makeRealtimeExample({}, { elementId, title = '', headerColumn, icon, store, styles, close }) {
    if (process.client) {
      // if (elementId) {
      //   function collectFilteredNodes(element, filter) {
      //     const filteredNodes = [];

      //     function traverse(node) {
      //       if (filter(node)) {
      //         filteredNodes.push(node);
      //       }
      //       if (node?.childNodes) {
      //         node.childNodes.forEach(child => traverse(child));
      //       }
      //     }

      //     traverse(element);
      //     return filteredNodes;
      //   }

      //   // Пример использования:
      //   function filterNodes(node) {
      //     try {
      //       return node.hasAttribute('data-html2canvas-ignore') ||
      //         node.classList.contains('v-popover') ||
      //         node.classList.contains('html2canvas-ignore');
      //     } catch (e) {
      //       return false;
      //     }
      //   }

      //   const rootElement = document.getElementById(elementId); // Замените на нужный элемент
      //   const filteredNodes = collectFilteredNodes(rootElement, filterNodes);

      //   if (close) {
      //     filteredNodes.forEach(el => el.style.display = 'initial')
      //   } else {
      //     filteredNodes.forEach(el => el.style.display = 'none')
      //   }
      // }

      const isVistatDesign = !styles ? true : false
      if (!close) await prepareElementForExport(elementId)

      if (isVistatDesign) {
        // standart Vistat design
        Promise.all(([
          !close ? new Promise((resolve, reject) => {
            return Konva.Image.fromURL(require(`~/assets/img/new-logo-full.png`), (image) => resolve(image), (error) => reject(error))
          }) : null,
          !close && icon ? new Promise((resolve, reject) => {
            return Konva.Image.fromURL(addServerPath(`/admin/icon_files/${icon}/picto_328fe5/`), (image) => resolve(image), (error) => reject(error))
          }) : null,
        ])).then(response => {
          const logo = response[0];
          const headerIcon = response[1]

          const element = document.getElementById(elementId)
          let realtimeExample = element.parentElement.parentElement.classList.contains('realtime-example')
            ? element.parentElement.parentElement
            : null;
          let wrapper = realtimeExample
            ? realtimeExample.querySelector('.realtime-example__wrapper')
            : null;
          let header = realtimeExample
            ? realtimeExample.querySelector('.realtime-example__header')
            : null;
          let headerIconImage = realtimeExample
            ? realtimeExample.querySelector('.realtime-example__header-icon')
            : null;
          let logoImage = realtimeExample
            ? realtimeExample.querySelector('.realtime-example__logo')
            : null;
          let headerWrapper = realtimeExample
            ? realtimeExample.querySelector('.realtime-example__header-wrapper')
            : null;

          // сброс всего при смене дизайна
          if (realtimeExample) {
            realtimeExample.parentElement.append(element)
            realtimeExample.remove()
          }

          if (!close) {
            if (!element.parentElement.parentElement.classList.contains('realtime-example')) {
              realtimeExample = document.createElement('div')
              wrapper = document.createElement('div')
              header = document.createElement('div')
              headerIconImage = document.createElement('img')
              logoImage = document.createElement('img')
              headerWrapper = document.createElement('div')
              realtimeExample.classList.add('realtime-example')
              wrapper.classList.add('realtime-example__wrapper')
              header.classList.add('realtime-example__header')
              headerIconImage.classList.add('realtime-example__header-icon')
              logoImage.classList.add('realtime-example__logo')
              headerWrapper.classList.add('realtime-example__header-wrapper')

              realtimeExample.appendChild(wrapper)
              headerWrapper.appendChild(header)
              wrapper.appendChild(headerWrapper)
              element.parentElement.insertBefore(realtimeExample, element)
              wrapper.appendChild(element)

              if (headerIcon && (!realtimeExample?.querySelector('.block-header.column') || realtimeExample?.querySelector('.block-header.column')?.parentElement?.style.display === 'none' || !realtimeExample?.querySelector('.--info') || !realtimeExample?.querySelector('.hexagon.fact'))) {
                const headerIconImageWrapper = document.createElement('div')
                headerIconImageWrapper.style.cssText = 'display: inline-block; min-width: 40px; text-align: right; margin-right: 13px;'
                headerIconImage.src = headerIcon.toDataURL()
                headerIconImageWrapper.appendChild(headerIconImage)
                headerWrapper.prepend(headerIconImageWrapper)
              }

              const logoImageWrapper = document.createElement('div')
              logoImageWrapper.style.cssText = 'max-width: 120px; display: flex; flex-direction: column; align-items: center; margin-left: 15px; margin-right: 20px; text-align: center;'
              logoImage.src = logo.toDataURL()
              logoImageWrapper.appendChild(logoImage)
              headerWrapper.append(logoImageWrapper)
            }

            // Костыли, из-за Александра
            // Если заголовок и иконка внутри блока
            const isHeaderColumn = realtimeExample?.querySelector('.block-header.column')
              && realtimeExample?.querySelector('.block-header.column')?.parentElement?.style.display !== 'none'
              || realtimeExample?.querySelector('.--info')
              || realtimeExample?.querySelector('.hexagon.fact')
              || realtimeExample?.querySelector('.facts-color__item')
              // || realtimeExample?.querySelector('.events-list')

            realtimeExample.style.cssText = `padding: 5px;`
            wrapper.style.cssText = `border: 1px solid #328FE6; overflow: hidden;`
            headerWrapper.style.cssText = 'display: flex; align-items: center; padding: 3px; margin: 1% 1% 0;';

            header.style.cssText = `width: 100%; text-align: left; font-size: 20px; font-family: 'Formular', 'Roboto', sans-serif; font-weight: 700; line-height: 1.2; color: #071013`
            element.style.transform = 'scale(0.98)'
            element.style.overflow = 'hidden'
            const substr = title.substring(0, title.lastIndexOf('.'));
            header.textContent = isHeaderColumn && !realtimeExample?.querySelector('.hexagon.fact') ? title.substring(0, title.lastIndexOf('.')) : title

            // иконки в header
            if (headerIcon && !isHeaderColumn) {
              const iconAspectRatio = headerIcon.width() / headerIcon.height();

              if (!headerIconImage) {
                headerIconImage = document.createElement('img')
                headerIconImage.classList.add('realtime-example__header-icon')
                const headerIconImageWrapper = document.createElement('div')
                headerIconImageWrapper.style.cssText = 'display: inline-block; min-width: 40px; text-align: right; margin-right: 13px;'
                headerIconImage.src = headerIcon.toDataURL()
                headerIconImageWrapper.appendChild(headerIconImage)
                headerWrapper.prepend(headerIconImageWrapper)
              }
              if (iconAspectRatio >= 1) {
                // Логотип шире контейнера — масштабируем по ширине
                headerIconImage.style.cssText = `width: 40px; height: ${40 / iconAspectRatio}px;`
              } else {
                // Логотип выше контейнера — масштабируем по высоте
                headerIconImage.style.cssText = `width: 40px; height: ${40 * iconAspectRatio}px;`
              }
            } else if (isHeaderColumn && headerIconImage?.parentElement) {
              headerIconImage.parentElement.remove()
            }

            if (logo) {
              const iconAspectRatio = logo.width() / logo.height();

              if (iconAspectRatio >= 1) {
                // Логотип шире контейнера — масштабируем по ширине
                logoImage.style.cssText = `width: 70px; height: ${70 / iconAspectRatio}px;`
              } else {
                // Логотип выше контейнера — масштабируем по высоте
                logoImage.style.cssText = `width: 70px; height: ${70 * iconAspectRatio}px;`
              }
            }
          }
        })
      } else {
        // Шаблонные и кастом дизайны
        Promise.all(([
          !close ? new Promise((resolve, reject) => {
            const logoCollectionID = styles?.nameAndLogo?.logoCollectionID;
            const userIcon = this.$auth?.user?.profile?.icon;
            if (logoCollectionID) {
              return Konva.Image.fromURL(addServerPath(`/admin/icon_files/${logoCollectionID}/picto_328fe5/`), (image) => resolve(image), (error) => reject(error))
            } else if (userIcon) {
              return Konva.Image.fromURL(addServerPath(`/admin/icon_files/${userIcon}/picto_328fe5/`), (image) => resolve(image), (error) => reject(error))
            } else {
              return Konva.Image.fromURL(require(`~/assets/img/new-logo-full.png`), (image) => resolve(image), (error) => reject(error))
            }
          }) : null,
          (
            !close && (styles?.background?.collectionID || styles?.background?.bgID) ?
              new Promise(async (resolve, reject) => {
                if (styles?.background?.collectionID) {
                  const response = await store.dispatch('backgrounds/fetchPublicObject', styles?.background?.collectionID)
                  return Konva.Image.fromURL(addServerPath(`${STORAGE_BACKGROUND_PATH}${response.picto}`), (image) => resolve(image), (error) => reject(error))
                } else if (styles?.background?.bgID) {
                  return Konva.Image.fromURL(BUILD_GENERAL_STORAGE_IMAGE_PATH(styles?.background?.bgID), (image) => resolve(image), (error) => reject(error))
                }
              })
              : null
          ),
          (
            !close && (styles?.nameAndLogo?.bgCollectionID || styles?.nameAndLogo?.bgID) ?
              new Promise(async (resolve, reject) => {
                if (styles?.nameAndLogo?.bgCollectionID) {
                  const response = await store.dispatch('backgrounds/fetchPublicObject', styles?.nameAndLogo?.bgCollectionID)
                  return Konva.Image.fromURL(addServerPath(`${STORAGE_BACKGROUND_PATH}${response.picto}`), (image) => resolve(image), (error) => reject(error))
                } else if (styles?.nameAndLogo?.bgID) {
                  return Konva.Image.fromURL(BUILD_GENERAL_STORAGE_IMAGE_PATH(styles?.nameAndLogo?.bgID), (image) => resolve(image), (error) => reject(error))
                }
              })
              : null
          ),
          !close ? new Promise(async (resolve, reject) => {
            fetch(require(`~/assets/svg/info-italic.svg`))
              .then((response) => response.text())
              .then((infoSvg) => {
                const coloredSvg = infoSvg.replace(/fill="[^"]*"/g, `fill="${styles?.nameAndLogo?.color ?? '#687782'}"`);
                const blob = new Blob([coloredSvg], { type: 'image/svg+xml' });
                const url = URL.createObjectURL(blob);

                return Konva.Image.fromURL(url, (image) => resolve(image), (error) => reject(error))
              })
          }) : null,
          !close && icon ? new Promise((resolve, reject) => {
            return Konva.Image.fromURL(addServerPath(`/admin/icon_files/${icon}/picto_328fe5/`), (image) => resolve(image), (error) => reject(error))
          }) : null,
        ])).then(response => {
          const logo = response[0];
          const blockBackground = response[1]
          const nameBackground = response[2]
          const infoIcon = response[3]
          const headerIcon = response[4]

          const element = document.getElementById(elementId)
          let realtimeExample = element.parentElement.parentElement.classList.contains('realtime-example')
            ? element.parentElement.parentElement
            : null;
          let wrapper = realtimeExample
            ? realtimeExample.querySelector('.realtime-example__wrapper')
            : null;
          let header = realtimeExample
            ? realtimeExample.querySelector('.realtime-example__header')
            : null;
          let footer = realtimeExample
            ? realtimeExample.querySelector('.realtime-example__footer')
            : null;
          let headerIconImage = realtimeExample
            ? realtimeExample.querySelector('.realtime-example__header-icon')
            : null;
          let logoImage = realtimeExample
            ? realtimeExample.querySelector('.realtime-example__logo')
            : null;
          let headerWrapper = realtimeExample
            ? realtimeExample.querySelector('.realtime-example__header-wrapper')
            : null;

          // сброс всего при смене дизайна
          if (realtimeExample) {
            realtimeExample.parentElement.append(element)
            realtimeExample.remove()
          }

          if (!close) {
            if (!element.parentElement.parentElement.classList.contains('realtime-example')) {
              realtimeExample = document.createElement('div')
              wrapper = document.createElement('div')
              header = document.createElement('div')
              footer = document.createElement('div')
              headerIconImage = document.createElement('img')
              logoImage = document.createElement('img')
              headerWrapper = document.createElement('div')
              realtimeExample.classList.add('realtime-example')
              wrapper.classList.add('realtime-example__wrapper')
              header.classList.add('realtime-example__header')
              footer.classList.add('realtime-example__footer')
              headerIconImage.classList.add('realtime-example__header-icon')
              logoImage.classList.add('realtime-example__logo')
              headerWrapper.classList.add('realtime-example__header-wrapper')

              realtimeExample.appendChild(wrapper)
              headerWrapper.appendChild(header)
              wrapper.appendChild(headerWrapper)
              element.parentElement.insertBefore(realtimeExample, element)
              wrapper.appendChild(element)
              wrapper.appendChild(footer)

              const infoIconImage = document.createElement('img')
              infoIconImage.src = infoIcon.toDataURL()
              infoIconImage.style.cssText = 'margin-right: 5px; width: 16px; height: 16px;'
              footer.textContent = 'Создано с помощью vistat.org'
              footer.prepend(infoIconImage)
              if (headerIcon && (!realtimeExample?.querySelector('.block-header.column') || realtimeExample?.querySelector('.block-header.column')?.parentElement?.style.display === 'none' || !realtimeExample?.querySelector('.--info') || !realtimeExample?.querySelector('.hexagon.fact'))) {
                const headerIconImageWrapper = document.createElement('div')
                headerIconImageWrapper.style.cssText = 'display: inline-block; min-width: 40px; text-align: right; margin-right: 13px;'
                headerIconImage.src = headerIcon.toDataURL()
                headerIconImageWrapper.appendChild(headerIconImage)
                headerWrapper.prepend(headerIconImageWrapper)
              }

              const logoImageWrapper = document.createElement('div')
              if (styles?.nameAndLogo?.showName && (this.$auth.user?.profile?.nickname || this.$auth.user?.username)) {
                const logoImageAuthor = document.createElement('span')
                logoImageWrapper.appendChild(logoImageAuthor)
                logoImageAuthor.textContent = this.$auth.user?.profile?.nickname || this.$auth.user?.username
              }
              logoImageWrapper.style.cssText = 'max-width: 120px; display: flex; flex-direction: column; align-items: center; margin-left: 15px; margin-right: 20px; text-align: center;'
              logoImage.src = logo.toDataURL()
              logoImageWrapper.appendChild(logoImage)
              headerWrapper.append(logoImageWrapper)
            }

            // Если заголовок и иконка внутри блока
            const isHeaderColumn = realtimeExample?.querySelector('.block-header.column')
              && realtimeExample?.querySelector('.block-header.column')?.parentElement?.style.display !== 'none'
              || realtimeExample?.querySelector('.--info')
              || realtimeExample?.querySelector('.hexagon.fact')
              // || realtimeExample?.querySelector('.events-list')

            realtimeExample.style.cssText = `padding: 5px;`
            wrapper.style.cssText = `border: ${styles?.border?.lineWidth}px ${styles?.border?.line} ${styles?.border?.color}; position: relative; z-index: 2; overflow: hidden;`
            footer.style.cssText = `padding: 8px 10px; margin: 0 1% 1%; text-align: 'left'; font-size: 12px; font-family: 'Formular', 'Roboto', sans-serif; font-weight: 700; line-height: 1.2; color: ${styles?.nameAndLogo?.color};`
            headerWrapper.style.cssText = 'display: flex; align-items: center; padding: 3px; margin: 1% 1% 0;';

            // фон хедера и футера
            const headerOpacity = (styles?.nameAndLogo?.opacity || styles?.nameAndLogo?.opacity === 0)
              ? styles?.nameAndLogo?.opacity / 100
              : 1;
            if (nameBackground && styles?.nameAndLogo?.type === 'image') {
              headerWrapper.style.position = 'relative'
              footer.style.position = 'relative'

              const headerOverlay = document.createElement('div')
              headerOverlay.style.cssText = `position: absolute; top: 0; left: 0; z-index: -1; width: 100%; height: 100%; opacity: ${headerOpacity}; background-size: cover; background-image: url(${nameBackground.toDataURL()})`
              const footerOverlay = document.createElement('div')
              footerOverlay.style.cssText = `position: absolute; top: 0; left: 0; z-index: -1; width: 100%; height: 100%; opacity: ${headerOpacity}; background-size: cover; background-image: url(${nameBackground.toDataURL()})`
              headerWrapper.appendChild(headerOverlay)
              footer.appendChild(footerOverlay)
            } else if (styles?.nameAndLogo?.type === 'color' && styles?.nameAndLogo?.bgColor) {
              headerWrapper.style.backgroundColor = `rgba(${hexToRgb(styles?.nameAndLogo?.bgColor)}, ${headerOpacity})`
              footer.style.backgroundColor = `rgba(${hexToRgb(styles?.nameAndLogo?.bgColor)}, ${headerOpacity})`
            } else {
              headerWrapper.style.background = 'none'
              footer.style.background = 'none'
            }

            // фон всего блока
            const blockOpacity = (styles?.background?.opacity || styles?.background?.opacity === 0)
              ? styles?.background?.opacity / 100
              : 1;

            if (blockBackground && (styles?.background?.type === 'image' || styles?.background?.type === 'bg-image')) {
              realtimeExample.style.position = 'relative'

              const overlay = document.createElement('div')
              overlay.style.cssText = `position: absolute; top: 0; left: 0; z-index: 1; width: 100%; height: 100%; opacity: ${blockOpacity}; background-size: cover; background-image: url(${blockBackground.toDataURL()})`
              realtimeExample.appendChild(overlay)
            } else if (styles?.background?.type === 'color' && styles?.background?.color) {
              realtimeExample.style.backgroundColor = `rgba(${hexToRgb(styles?.background?.color)}, ${blockOpacity})`
            } else {
              realtimeExample.style.background = 'none'
            }

            header.style.cssText = `width: 100%; text-align: ${!headerIcon || isHeaderColumn ? 'center' : 'left'}; font-size: ${styles?.nameAndLogo?.nameFontSize}px; font-family: 'Formular', 'Roboto', sans-serif; font-weight: 700; line-height: 1.2; color: ${styles?.nameAndLogo?.color}`
            element.style.transform = 'scale(0.98)'
            element.style.overflow = 'hidden'
            const substr = title.substring(0, title.lastIndexOf('.'));
            header.textContent = isHeaderColumn && !realtimeExample?.querySelector('.hexagon.fact') ? (substr.length ? substr : title) : title

            // иконки в header
            if (headerIcon && !isHeaderColumn) {
              const iconAspectRatio = headerIcon.width() / headerIcon.height();
              const iconWidth = Number(styles?.nameAndLogo?.logoSize?.slice(0, 2))
              const iconHeight = Number(styles?.nameAndLogo?.logoSize?.slice(3, 5))
              const targetAspectRatio = iconWidth / iconHeight;

              if (!headerIconImage) {
                headerIconImage = document.createElement('img')
                headerIconImage.classList.add('realtime-example__header-icon')
                const headerIconImageWrapper = document.createElement('div')
                headerIconImageWrapper.style.cssText = 'display: inline-block; min-width: 40px; text-align: right; margin-right: 13px;'
                headerIconImage.src = headerIcon.toDataURL()
                headerIconImageWrapper.appendChild(headerIconImage)
                headerWrapper.prepend(headerIconImageWrapper)
              }
              if (iconAspectRatio > targetAspectRatio) {
                // Логотип шире контейнера — масштабируем по ширине
                headerIconImage.style.cssText = `width: ${iconWidth}px; height: ${iconWidth / iconAspectRatio}px;`
              } else {
                // Логотип выше контейнера — масштабируем по высоте
                headerIconImage.style.cssText = `width: ${iconHeight * iconAspectRatio}px; height: ${iconHeight}px;`
              }
            } else if (isHeaderColumn && headerIconImage?.parentElement) {
              headerIconImage.parentElement.remove()
            }

            const author = logoImage.parentElement.querySelector('span')
            if (author) author.style.cssText = `text-align: center; font-size: ${styles?.nameAndLogo?.authorFontSize}px;`
            if (!author && styles?.nameAndLogo?.showName && (this.$auth.user?.profile?.nickname || this.$auth.user?.username)) {
              const logoImageAuthor = document.createElement('span')
              logoImageAuthor.textContent = this.$auth?.user?.profile?.nickname || this.$auth?.user?.username
              logoImage.parentElement.prepend(logoImageAuthor)
              logoImageAuthor.style.cssText = `text-align: center; font-size: ${styles?.nameAndLogo?.authorFontSize}px;`
            } else if (author && !styles?.nameAndLogo?.showName) {
              author.remove()
            }

            if (logo) {
              const iconAspectRatio = logo.width() / logo.height();
              const iconWidth = Number(styles?.nameAndLogo?.logoSize?.slice(0, 2))
              const iconHeight = Number(styles?.nameAndLogo?.logoSize?.slice(3, 5))
              const targetAspectRatio = iconWidth / iconHeight;

              if (iconAspectRatio > targetAspectRatio) {
                // Логотип шире контейнера — масштабируем по ширине
                logoImage.style.cssText = `width: ${iconWidth}px; height: ${iconWidth / iconAspectRatio}px;`
              } else {
                // Логотип выше контейнера — масштабируем по высоте
                logoImage.style.cssText = `width: ${iconHeight * iconAspectRatio}px; height: ${iconHeight}px;`
              }
            }
          }
        })
      }
    }
  },
  makeScreenshotOfSection({}, { elementId, fileName = 'скриншот', title = '', store, icon, headerColumn, readyImage, styles }) {
    if (process.client) {
      const infographicStyles = styles
      const isCustomDesign = !readyImage && !infographicStyles ? false : true

      return new Promise((resolve, reject) => {
        import("dom-to-image").then(async ({ default: domtoimage }) => {
          let element
          let restoreImages = () => {}
          if (!readyImage) {
            element = await prepareElementForExport(elementId);
            if (!element) {
              reject(new Error(`Element "${elementId}" not found`))
              return
            }
            // изменение стилей для скриншота
            if (element?.classList?.contains('wrap__copy')) {
              element.querySelectorAll('.quote__start, .quote__end').forEach(el => {
                el.style.setProperty('--quote-bg', 'transparent')
              })
            }
            if (element?.classList?.contains('list')) {
              element.classList.add('--editable')
            }
            const images = Array.from(element?.querySelectorAll('img') || [])
            const replacedImages = []
            await Promise.all(images.map(async (img) => {
              const source = img.currentSrc || img.getAttribute('src') || img.src
              if (!source || source.startsWith('data:') || source.startsWith('blob:')) return
              try {
                const blob = await this.$axios.$get(`/misc/download_image/?url=${encodeURIComponent(source)}`, { responseType: 'blob' })
                if (!blob) return
                const dataUrl = await new Promise((resolve, reject) => {
                  const reader = new FileReader()
                  reader.onloadend = () => resolve(reader.result)
                  reader.onerror = reject
                  reader.readAsDataURL(blob)
                })

                const originalSrc = img.getAttribute('src')
                const originalSrcset = img.getAttribute('srcset')
                replacedImages.push({ img, originalSrc, originalSrcset })

                img.removeAttribute('srcset')
                img.src = dataUrl
              } catch (e) {}
            }))

            restoreImages = () => {
              replacedImages.forEach(({ img, originalSrc, originalSrcset }) => {
                if (!img?.isConnected) return
                if (originalSrc === null) img.removeAttribute('src')
                else img.setAttribute('src', originalSrc)

                if (originalSrcset === null) img.removeAttribute('srcset')
                else img.setAttribute('srcset', originalSrcset)
              })
            }
          }

          function filter(node) {
            try {
              if (node.hasAttribute('data-html2canvas-ignore') || node.classList.contains('v-popover') || node.classList.contains('html2canvas-ignore')) return false
              if (node.tagName === 'IMG' && (node.naturalWidth === 0 || node.naturalHeight === 0)) return false
              return true
            } catch (e) {
              return true
            }
          }

          const scale = parseFloat((window.devicePixelRatio ?? 1).toFixed(1));

          Promise.all(([
            (
              !readyImage ?
                new Promise((resolve) => {
                  domtoimage.toPng(element, {
                    width: Math.ceil(element.clientWidth * scale),
                    height: Math.ceil(element.clientHeight * scale),
                    style: {
                      width: `${element.clientWidth}px`,
                      height: `${element.clientHeight}px`,
                      transform: "scale(" + scale + ")",
                      transformOrigin: "top left"
                    },
                    filter: filter
                  }).then(dataUrl => {
                    return Konva.Image.fromURL(dataUrl, (image) => {
                      resolve(image)
                    })
                  })
                })
                : new Promise((resolve) => {
                  return Konva.Image.fromURL(require(`~/assets/img/${readyImage}`), (image) => resolve(image), (error) => reject(error))
                })
            ),
            new Promise((resolve, reject) => {
              const logoCollectionID = isCustomDesign && infographicStyles?.nameAndLogo?.logoCollectionID;
              const userIcon = this.$auth.user?.profile?.icon;
              if (isCustomDesign && logoCollectionID) {
                return Konva.Image.fromURL(addServerPath(`/admin/icon_files/${logoCollectionID}/picto_328fe5/`), (image) => resolve(image), (error) => reject(error))
              } else if (isCustomDesign && userIcon) {
                return Konva.Image.fromURL(addServerPath(`/admin/icon_files/${userIcon}/picto_328fe5/`), (image) => resolve(image), (error) => reject(error))
              } else {
                return Konva.Image.fromURL(require(`~/assets/img/new-logo-full.png`), (image) => resolve(image), (error) => reject(error))
              }
            }),
            (
              isCustomDesign && (infographicStyles?.background?.collectionID || infographicStyles?.background?.bgID) ?
                new Promise(async (resolve, reject) => {
                  if (infographicStyles?.background?.collectionID) {
                    const response = await store.dispatch('backgrounds/fetchPublicObject', infographicStyles?.background?.collectionID)
                    return Konva.Image.fromURL(addServerPath(`${STORAGE_BACKGROUND_PATH}${response.picto}`), (image) => resolve(image), (error) => reject(error))
                  } else if (infographicStyles?.background?.bgID) {
                    return Konva.Image.fromURL(BUILD_GENERAL_STORAGE_IMAGE_PATH(infographicStyles?.background?.bgID), (image) => resolve(image), (error) => reject(error))
                  }
                })
                : null
            ),
            (
              isCustomDesign && (infographicStyles?.nameAndLogo?.bgCollectionID || infographicStyles?.nameAndLogo?.bgID) ?
                new Promise(async (resolve, reject) => {
                  if (infographicStyles?.nameAndLogo?.bgCollectionID) {
                    const response = await store.dispatch('backgrounds/fetchPublicObject', infographicStyles?.nameAndLogo?.bgCollectionID)
                    return Konva.Image.fromURL(addServerPath(`${STORAGE_BACKGROUND_PATH}${response.picto}`), (image) => resolve(image), (error) => reject(error))
                  } else if (infographicStyles?.nameAndLogo?.bgID) {
                    return Konva.Image.fromURL(BUILD_GENERAL_STORAGE_IMAGE_PATH(infographicStyles?.nameAndLogo?.bgID), (image) => resolve(image), (error) => reject(error))
                  }
                })
                : null
            ),
            new Promise(async (resolve, reject) => {
              fetch(require(`~/assets/svg/info-italic.svg`))
                .then((response) => response.text())
                .then((infoSvg) => {
                  const coloredSvg = infoSvg.replace(/fill="[^"]*"/g, `fill="${infographicStyles?.nameAndLogo?.color ?? '#687782'}"`);
                  const blob = new Blob([coloredSvg], { type: 'image/svg+xml' });
                  const url = URL.createObjectURL(blob);

                  return Konva.Image.fromURL(url, (image) => resolve(image), (error) => reject(error))
                })
            }),
            icon ? new Promise((resolve, reject) => {
              return Konva.Image.fromURL(addServerPath(`/admin/icon_files/${icon}/picto_328fe5/`), (image) => resolve(image), (error) => reject(error))
            }) : null,
          ])).then(response => {
            const image = response[0];
            const logo = response[1];
            const blockBackground = response[2];
            const nameBackground = response[3];
            const infoIcon = response[4];
            const headerIcon = response[5];

            const offscreenCanvas = document.createElement('canvas');
            offscreenCanvas.width = image.width();
            offscreenCanvas.height = image.height();

            const stage = new Konva.Stage({
              width: image.width(),
              height: image.height(),
              container: offscreenCanvas,
            })

            const isMobileSize = window.innerWidth <= 640 ? 1.6 : 1
            const isHeaderColumn = element?.querySelector('.block-header.column')
              && element?.querySelector('.block-header.column')?.parentElement?.style.display !== 'none'
              || element?.querySelector('.--info')
              || element?.querySelector('.hexagon.fact')
              // || element?.querySelector('.events-list')
            const substr = title.substring(0, title.lastIndexOf('.'));

            const header = new Konva.Text({
              width: stage.width() - 180 * scale,
              y: 10 * scale,
              x: 20 * scale,
              text: isHeaderColumn && !element?.querySelector('.hexagon.fact') ? (substr.length ? substr : title) : title,
              fontSize: (isCustomDesign ? infographicStyles?.nameAndLogo?.nameFontSize : 20) * scale / isMobileSize,
              fontFamily: 'Formular',
              lineHeight: 1.2,
              fontStyle: '700',
              fill: isCustomDesign ? (infographicStyles?.nameAndLogo?.color ?? '#687782') : '#071013',
              align: isCustomDesign && (!headerIcon || isHeaderColumn) ? 'center' : 'left'
            })

            const logoGroup = new Konva.Group({
              width: 140 * scale,
              y: 10 * scale,
              x: stage.width() - (150 * scale),
            })

            let author
            if (isCustomDesign && infographicStyles?.nameAndLogo?.showName && (this.$auth?.user?.profile?.nickname || this.$auth?.user?.username)) {
              author = new Konva.Text({
                width: logoGroup.width(),
                text: this.$auth?.user?.profile?.nickname || this.$auth?.user?.username,
                fontSize: infographicStyles?.nameAndLogo?.authorFontSize * scale,
                fontFamily: 'Formular',
                lineHeight: 1.2,
                weight: 700,
                fill: infographicStyles?.nameAndLogo?.color ?? '#687782',
                align: 'center'
              })
              logoGroup.add(author)
            }

            const logoAspectRatio = logo.width() / logo.height();
            if (isCustomDesign) {
              const logoWidth = Number(infographicStyles?.nameAndLogo?.logoSize?.slice(0, 2)) * scale
              const logoHeight = Number(infographicStyles?.nameAndLogo?.logoSize?.slice(3, 5)) * scale
              const targetAspectRatio = logoWidth / logoHeight;

              if (logoAspectRatio > targetAspectRatio) {
                // Логотип шире контейнера — масштабируем по ширине
                logo.width(logoWidth);
                logo.height(logoWidth / logoAspectRatio);
              } else {
                // Логотип выше контейнера — масштабируем по высоте
                logo.height(logoHeight);
                logo.width(logoHeight * logoAspectRatio);
              }
            } else {
              if (logoAspectRatio >= 1) {
                // Если ширина по пропорциям >= 1 масштабируем по высоте
                logo.width(logoGroup.width() / 2);
                logo.height(logoGroup.width() / 2 / logoAspectRatio);
              } else {
                // Если контейнер выше, масштабируем по ширине
                logo.width(logoGroup.width() / 2);
                logo.height(logoGroup.width() / 2 * logoAspectRatio);
              }
            }

            const textHeight = header.height() + 20 * scale

            // Центрируем логотип внутри группы
            logo.x((logoGroup.width() - logo.width()) / 2);
            if (isCustomDesign && infographicStyles?.nameAndLogo?.showName && (this.$auth?.user?.profile?.nickname || this.$auth?.user?.username) && author) {
              logo.y(author.height() + 5 * scale)
              logoGroup.height(author.height() + logo.height() + 5 * scale)
            } else {
              // logoGroup.y(textHeight / 2 - logo.height() / 2)
              logoGroup.height(logo.height())
            }

            logoGroup.add(logo)

            if (headerIcon) {
              const iconAspectRatio = headerIcon.width() / headerIcon.height();
              if (isCustomDesign) {
                const iconWidth = Number(infographicStyles?.nameAndLogo?.logoSize?.slice(0, 2)) * scale
                const iconHeight = Number(infographicStyles?.nameAndLogo?.logoSize?.slice(3, 5)) * scale
                const targetAspectRatio = iconWidth / iconHeight;

                if (iconAspectRatio > targetAspectRatio) {
                // Логотип шире контейнера — масштабируем по ширине
                  headerIcon.width(iconWidth);
                  headerIcon.height(iconWidth / iconAspectRatio);
                } else {
                // Логотип выше контейнера — масштабируем по высоте
                  headerIcon.height(iconHeight);
                  headerIcon.width(iconHeight * iconAspectRatio);
                }
              } else {
                if (iconAspectRatio >= 1) {
                // Если ширина по пропорциям >= 1 масштабируем по высоте
                  headerIcon.width(70);
                  headerIcon.height(70 / iconAspectRatio);
                } else {
                // Если контейнер выше, масштабируем по ширине
                  headerIcon.width(70);
                  headerIcon.height(70 * iconAspectRatio);
                }
              }
              headerIcon.setAttrs({ x: 20 * scale, y: Math.max(textHeight, logoGroup.height() + 10 * scale) / 2 - headerIcon.height() / 2 })
              header.setAttrs({ x: Math.max(headerIcon.width() + 40 * scale, 75 * scale) })
            }

            const headerGroup = new Konva.Group({
              width: stage.width(),
              height: Math.max(textHeight, logoGroup.height() + 20 * scale),
              clip: {
                x: 0,
                y: 0,
                width: stage.width(),
                height: Math.max(textHeight, logoGroup.height() + 20 * scale)
              }
            })

            let footer;
            let footerGroup;
            if (isCustomDesign) {
              footer = new Konva.Text({
                width: stage.width(),
                y: 10 * scale,
                x: 22 * scale,
                text: 'Создано с помощью vistat.org',
                fontSize: 12 * scale,
                fontFamily: 'Formular',
                lineHeight: 1.2,
                weight: 700,
                fill: (infographicStyles?.nameAndLogo?.color ?? '#687782') ?? '#071013',
                align: 'left'
              })

              infoIcon.setAttrs({ x: 0, y: 8 * scale, width: 16 * scale, height: 16 * scale })

              footerGroup = new Konva.Group({
                width: stage.width(),
                height: 34 * scale,
                y: headerGroup.height() + image.height(),
                clip: {
                  x: 0,
                  y: 0,
                  width: stage.width(),
                  height: 34 * scale
                }
              })
            }

            if (nameBackground && infographicStyles?.nameAndLogo?.type === 'image') {
              const nameBackground2 = cloneDeep(nameBackground)
              const nameAndLogoOpacity = (infographicStyles?.nameAndLogo?.opacity || infographicStyles?.nameAndLogo?.opacity === 0)
                ? infographicStyles?.nameAndLogo?.opacity / 100
                : 1;

              nameBackground.setAttrs({
                opacity: nameAndLogoOpacity
              });
              nameBackground2.setAttrs({
                opacity: nameAndLogoOpacity
              });

              // Сохранение пропорций
              const nameRatio = nameBackground.width() / nameBackground.height();
              const headerRatio = headerGroup.width() / headerGroup.height()
              const footerRatio = footerGroup.width() / footerGroup.height()

              if (headerRatio > nameRatio) {
                nameBackground.width(headerGroup.width());
                nameBackground.height(headerGroup.width() / nameRatio);
              } else {
                nameBackground.width(headerGroup.height() * nameRatio);
                nameBackground.height(headerGroup.height());
              }

              // Центрируем nameBackground внутри headerGroup
              nameBackground.x((headerGroup.width() - nameBackground.width()) / 2);
              nameBackground.y((headerGroup.height() - nameBackground.height()) / 2);

              headerGroup.add(nameBackground);
              nameBackground.moveToBottom();

              if (footerRatio > nameRatio) {
                nameBackground2.width(footerGroup.width());
                nameBackground2.height(footerGroup.width() / nameRatio);
              } else {
                nameBackground2.width(footerGroup.height() * nameRatio);
                nameBackground2.height(footerGroup.height());
              }

              // Центрируем nameBackground2 внутри footerGroup
              nameBackground2.x((footerGroup.width() - nameBackground2.width()) / 2);
              nameBackground2.y((footerGroup.height() - nameBackground2.height()) / 2);

              footerGroup.add(nameBackground2);
              nameBackground2.moveToBottom();
            }

            if (textHeight < headerGroup.height()) {
              [header].filter(x => x !== null).forEach((node) => {
                node.setAttrs({
                  y: Math.ceil(node.y() + (headerGroup.height() - textHeight - 10 * scale) / 2)
                })
              })
            }

            const calcedOpacity = (infographicStyles?.nameAndLogo?.opacity || infographicStyles?.nameAndLogo?.opacity === 0) ? infographicStyles?.nameAndLogo?.opacity / 100 : 1
            const groupFill = !infographicStyles?.nameAndLogo?.bgColor || infographicStyles?.nameAndLogo?.type !== 'color' ? 'rgba(255,255,255,0)'
              : `rgba(${hexToRgb(infographicStyles?.nameAndLogo?.bgColor)}, ${calcedOpacity})`

            if (isCustomDesign && !nameBackground) {
              headerGroup.add(
                new Konva.Rect({
                  width: stage.width(),
                  height: headerGroup.height(),
                  fill: groupFill,
                }),
              )
            }
            if (!isHeaderColumn && headerIcon) {
              headerGroup.add(headerIcon)
            }
            headerGroup.add(
              header,
              logoGroup
            )


            const content = new Konva.Layer()

            if (isCustomDesign) {
              footerGroup.add(
                new Konva.Rect({
                  width: stage.width(),
                  height: footerGroup.height(),
                  fill: groupFill,
                }),
                footer,
                infoIcon
              )
              footerGroup.moveToBottom()

              // image.y(headerGroup.height() + (stage.height() - headerGroup.height() - footerGroup.height()) / 4)
              image.y(headerGroup.height())

              content.add(headerGroup, image, footerGroup)
              stage.height(stage.height() + headerGroup.height() + footerGroup.height())
            } else {
              // image.y(headerGroup.height() + (stage.height() - headerGroup.height() - footerGroup.height()) / 4)
              image.y(headerGroup.height())

              content.add(headerGroup, image)
              stage.height(stage.height() + headerGroup.height())
            }

            stage.height(stage.height() + 16 * scale)
            stage.width(stage.width() + 16 * scale)

            stage.setAttrs({ fill: `rgba(255,255,255,1)` })

            content.children.forEach(node => {
              node.x(node.x() + 8 * scale)
              node.y(node.y() + 8 * scale)
            })

            const bg = new Konva.Group({
              width: stage.width(),
              height: stage.height(),
            })

            bg.add(new Konva.Rect({
              x: 0,
              y: 0,
              width: stage.width(),
              height: stage.height(),
              fill: infographicStyles?.background?.opacity === 0 ? 'rgba(255,255,255,1)' : `rgba(${hexToRgb(infographicStyles?.background?.color ?? '#F9FEFF')}, ${(infographicStyles?.background?.opacity || infographicStyles?.background?.opacity === 0) ? infographicStyles?.background?.opacity / 100 : '1'})`,
            }))

            const borders = {
              solid: [], // "⸻"
              dotted: [2, 6], // "· · · · ·"
              // shortdash: [10, 5], // "------"
              dashed: [15, 10], // "‒ ‒ ‒"
              // longdash: [25, 15], // "— — —"
              // dashdot: [15, 5, 5, 5], // "Длинное тире - короткое тире"
              // longdashdot: [30, 10, 2, 10], // "Очень длинное тире - точка"
              // longdashdotdot: [15, 5, 2, 3, 2, 5], // "Длинное тире - точка-точка"
              // shortdashdot: [10, 5, 2, 5], // "Тире-точка"
              // shortdashdotdot: [10, 5, 2, 3, 2, 5], // "Тире-точка-точка"
              // shortdot: [2, 8], // "Точки через двойной интервал"
            }

            if (blockBackground) {
              const blockOpacity = (infographicStyles?.background?.opacity || infographicStyles?.background?.opacity === 0)
                ? infographicStyles?.background?.opacity / 100
                : 1;

              blockBackground.setAttrs({
                width: stage.width(),
                height: stage.height(),
                opacity: blockOpacity
              });
              // фон
              bg.add(blockBackground)
            }

            if (isCustomDesign && infographicStyles?.border?.line !== 'none') {
              bg.add(
                new Konva.Rect({
                  stroke: infographicStyles?.border?.color ?? '#328FE6',
                  strokeWidth: infographicStyles?.border?.lineWidth ?? 2,
                  dash: borders[infographicStyles?.border?.line],
                  fill: 'rgba(255,255,255,0)',
                  x: 4 * scale,
                  y: 4 * scale,
                  width: bg.width() - 8 * scale,
                  height: bg.height() - 8 * scale,
                  ...(infographicStyles?.border?.shadow ? {
                    shadowColor: infographicStyles?.border?.color ?? '#F9FEFF',
                    shadowBlur: 10 * scale,
                    shadowOffset: { x: 0, y: 0 },
                    shadowOpacity: (infographicStyles?.border?.opacity || infographicStyles?.border?.opacity === 0) ? infographicStyles?.border?.opacity : 1,
                  } : {})
                })
              )
            } else if (!isCustomDesign) {
              bg.add(
                // Фон
                new Konva.Rect({
                  width: bg.width(),
                  height: bg.height(),
                  fill: '#fff'
                }),
                new Konva.Rect({
                  stroke: '#328FE6',
                  strokeWidth: 2,
                  x: 4,
                  y: 4,
                  width: bg.width() - 8,
                  height: bg.height() - 8,
                })
              )
            }

            content.add(bg)
            bg.moveToBottom()

            const whiteBg = new Konva.Rect({
              width: stage.width(),
              height: stage.height(),
              x: 0,
              y: 0,
              fill: 'white'
            })
            content.add(whiteBg)
            whiteBg.setZIndex(0)

            stage.add(content)

            stage.draw()

            if (!readyImage) {
              const link = document.createElement('a');
              link.href = stage.toDataURL({ mimeType: 'image/jpeg', pixelRatio: 1, quality: 1 });

              link.download = `${fileName}.jpeg`;
              link.click();

              // сброс измененных стилей блока для скриншота
              if (element?.classList?.contains('wrap__copy')) {
                element.querySelectorAll('.quote__start, .quote__end').forEach(el => {
                  el.style.setProperty('--quote-bg', '#F9FEFF')
                })
              }
              if (element?.classList?.contains('list')) {
                element.classList.remove('--editable')
              }
              restoreImages()
              stage.destroy()
              resolve()
            } else {
              const imgUrl = stage.toDataURL({ mimeType: 'image/png', pixelRatio: 1, quality: 1 })
              stage.destroy()
              resolve(imgUrl)
            }

          }).catch((err) => {
            restoreImages()
            reject(err)
          })
        }).catch(reject);
      })
    }
  },
  fetchMainPageData({ dispatch }, { query, per_page }) {
    const page = 0
    const promises = [
      dispatch('objects/publicObjects', {
        q: query.q ?? '',
        limit: per_page,
        offset: page * per_page,
        order: '-total_score',
      }),
      dispatch('art/publicObjects', {
        q: query.q ?? '',
        limit: per_page,
        offset: page * per_page,
      }),
    ]
    categories.get(page).forEach((cat) => promises.push(dispatch('objects/publicObjects', {
      category: cat.id,
      limit: 7,
      order: '-total_score',
    })))
    return Promise.all(promises)
  }
}
